import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService } from 'primeng/api';
import { Constant } from 'src/app/shared/service/utils/contant';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { SyntheseRecettesNettesComponent } from '../synthese-recettes-nettes/synthese-recettes-nettes.component';

@Component({
  selector: 'app-recouvrement',
  templateUrl: './recouvrement.component.html',
  styleUrl: './recouvrement.component.scss'
})
export class RecouvrementComponent implements OnInit {

  exercice: number = new Date().getFullYear();
  mois: number = new Date().getMonth() + 1;
  search: string = '';

  recouvrements: any[] = [];
  paginatedProjets: any[] = [];
  first = 0;
  rows = 10;
  totalRecords = 0;
  isLoading = false;

  selectedTitre: any = null;
  recouvrementForm: any = {};

  moisItems = [
    { value: 1, label: 'Janvier' },
    { value: 2, label: 'Février' },
    { value: 3, label: 'Mars' },
    { value: 4, label: 'Avril' },
    { value: 5, label: 'Mai' },
    { value: 6, label: 'Juin' },
    { value: 7, label: 'Juillet' },
    { value: 8, label: 'Août' },
    { value: 9, label: 'Septembre' },
    { value: 10, label: 'Octobre' },
    { value: 11, label: 'Novembre' },
    { value: 12, label: 'Décembre' },
  ];

  @ViewChild('recouvrementModal') recouvrementModal: any;

  constructor(
    private modalService: NgbModal,
    private paramService: ParameterService,
    private localStorage: LocalStorageService,
    private messageService: MessageService,
    private ngxService: NgxUiLoaderService
  ) { }

  ngOnInit(): void {
    const stored = this.localStorage.getExerciceToUserToSuivieEvaluation();
    if (stored) {
      this.exercice = Number(stored) || new Date().getFullYear();
    }
    this.loadData();
  }

  loadData(): void {
    this.isLoading = false;
    this.ngxService.start();
    this.paramService.getBordereauRecouvrements({
      annee: this.exercice,
      mois: this.mois,
      search: this.search || ''
    }).subscribe(
      (response: any) => {
        this.recouvrements = response.data || [];
        this.totalRecords = this.recouvrements.length;
        this.updatePaginated();
        this.isLoading = true;
        this.ngxService.stop();
      },
      (error: any) => {
        this.isLoading = true;
        this.ngxService.stop();
        this.messageService.add({
          severity: 'error',
          summary: Constant.suiviTitle,
          detail: error?.error?.message || 'Une erreur est survenue lors du chargement des recouvrements'
        });
      }
    );
  }

  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
    this.updatePaginated();
  }

  updatePaginated() {
    this.paginatedProjets = this.recouvrements.slice(this.first, this.first + this.rows);
  }

  get dateRecouvrementDisplay(): string {
    return this.formatDateFR(this.recouvrementForm.date_recouvrement);
  }

  set dateRecouvrementDisplay(value: string) {
    this.recouvrementForm.date_recouvrement = this.parseDateFR(value);
  }

  formatDateFR(iso?: string): string {
    if (!iso) return '';
    const [y, m, d] = (iso || '').split('-');
    if (!y || !m || !d) return iso;
    return `${d}/${m}/${y}`;
  }

  parseDateFR(fr: string): string {
    if (!fr) return '';
    const [d, m, y] = fr.split('/');
    if (!d || !m || !y || y.length !== 4) return '';
    return `${y}-${m}-${d}`;
  }

  getMoisLabel(periode: any): string {
    if (periode === null || periode === undefined || String(periode).trim() === '') {
      return '-';
    }
    const str = String(periode).trim();
    const num = Number(str);
    if (!isNaN(num) && num >= 1 && num <= 12) {
      return this.moisItems[num - 1]?.label || str;
    }
    const isoMatch = str.match(/^\d{4}-(\d{2})/);
    if (isoMatch) {
      const m = Number(isoMatch[1]);
      return (this.moisItems[m - 1]?.label) || str;
    }
    return str;
  }

  openModal(titre: any) {
    this.selectedTitre = titre;
    this.recouvrementForm = {
      montant_recouvre: titre.recouvrement?.montant_recouvre || 0,
      date_recouvrement: titre.recouvrement?.date_recouvrement || new Date().toISOString().slice(0, 10),
      observations: titre.recouvrement?.observations || '',
      reste_recouvrer: titre.recouvrement?.reste_recouvrer || titre.montant,
    };
    this.modalService.open(this.recouvrementModal, { centered: true, backdrop: 'static', size: 'lg' });
  }

  calculateReste() {
    this.recouvrementForm.reste_recouvrer = Math.max(
      0,
      Number(this.selectedTitre?.montant || 0) - Number(this.recouvrementForm.montant_recouvre || 0)
    );
  }

  save() {
    if (!this.selectedTitre) {
      return;
    }
    if (!this.recouvrementForm.montant_recouvre || Number(this.recouvrementForm.montant_recouvre) < 10000) {
      this.messageService.add({
        severity: 'warn',
        summary: Constant.suiviTitle,
        detail: 'Veuillez saisir un montant recouvré valide (minimum 10 000)'
      });
      return;
    }
    this.calculateReste();
    this.ngxService.start();
    this.paramService.saveBordereauRecouvrement(this.selectedTitre.reference, this.recouvrementForm).subscribe(
      (response: any) => {
        this.ngxService.stop();
        this.modalService.dismissAll();
        this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
        this.loadData();
      },
      (error: any) => {
        this.ngxService.stop();
        this.messageService.add({
          severity: 'error',
          summary: Constant.suiviTitle,
          detail: error?.error?.message || 'Une erreur est survenue'
        });
      }
    );
  }

  openSynthese(): void {
    const modalRef = this.modalService.open(SyntheseRecettesNettesComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl'
    });
    modalRef.componentInstance.titre = 'Synthèse des recouvrements';
  }
}
